import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

export const SET_TAGS = 'SET_TAGS';
export const SET_IDEA = 'SET_IDEA';
export const SET_IDEAS = 'SET_IDEAS';
export const SET_COMMENT = 'SET_COMMENT';
export const SET_COMMENTS = 'SET_COMMENTS';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const SET_FOCUS_ON_IDEA = 'SET_FOCUS_ON_IDEA';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_TAGS](state, tags) {
		Vue.set(state, 'tags', tags);
	},
	[SET_IDEA](state, idea) {
		Vue.set(state.ideas, idea.id, idea);
	},
	[SET_IDEAS](state, ideas) {
		Vue.set(state, 'ideas', ideas);
	},
	[SET_COMMENT](state, comment) {
		Vue.set(state.comments, comment.id, comment);
	},
	[SET_COMMENTS](state, comments) {
		Vue.set(state, 'comments', comments);
	},
	[DELETE_COMMENT](state, { commentId }) {
		Vue.delete(state.comments, commentId);
	},
	[SET_FOCUS_ON_IDEA](state, { ideaId }) {
		Vue.set(state, 'focusOnIdea', ideaId);
	},
};

export default mutations;
